<template>
	<footer class="site-footer">

		<div class="site-footer__inner container">

			<div class="site-footer__nav">
				<ul class="site-footer__links stripped-list">
					<li>
						<router-link
							:to="{ name: $GLOBALS.ROUTE_HOME }"
							class="site-footer__link"
						>
							Home
						</router-link>
					</li>
					<li>
						<button
							@click="$store.commit('modalVisible', {modal: 'chooseTopic', boolean: true})"
							type="button"
							class="btn--no-style site-footer__link"
						>
							Browse Topics
						</button>
					</li>
					<li>
						<router-link
							to="/information"
							class="site-footer__link"
						>
							Information
						</router-link>
					</li>
					<li>
						<router-link
							to="/contact-us"
							class="site-footer__link"
						>
							Contact Us
						</router-link>
					</li>
					<li>
						<router-link
							to="/privacy-policy"
							class="site-footer__link"
						>
							Privacy Policy
						</router-link>
					</li>
					<li>
						<router-link
							to="/accessibility"
							class="site-footer__link"
						>
							Accessibility
						</router-link>
					</li>
					<li>
						<button
							@click="removeCookieSettings"
							type="button"
							class="btn--no-style site-footer__link"
						>
							Cookie Settings
						</button>
					</li>
				</ul>

				<ul
					v-if="$store.state.save && $store.state.save.content.length > 0"
					class="site-footer__actions stripped-list"
				>
					<li>
						<button
							@click="$store.commit('modalVisible', {modal: 'savedInfo', boolean: true})"
							type="button"
							class="btn--no-style site-footer__link"
						>
							My Saved Info
						</button>
					</li>
					<li>
						<router-link
							:to="{ name: $GLOBALS.ROUTE_SHARE_CONTENT }"
							class="site-footer__link"
						>
							Share your saved info
						</router-link>
					</li>
				</ul>
			</div>

			<div class="site-footer__info">
				<div class="site-footer__copyright">
					&copy; NATIONAL AIDS TRUST {{ currentYear }}. All rights reserved.
				</div>

				<div class="site-footer__signiture">
					Website by <br/>
					<a
						href="https://www.reasondigital.com"
						target="_blank"
						rel="noopener"
						class="site-footer__signiture-link"
					>
						Reason Digital
					</a>
				</div>
			</div>
		</div>

	</footer>
</template>

<script>
// Styles
import '@/sass/layout/_footer.scss';

export default {
	computed: {
		currentYear: function() {
			return new Date().getFullYear();
		}
	},
	methods: {
		removeCookieSettings() {
			
			if (this.$route.path === '/privacy-policy') {
				this.$store.dispatch('updateAnalyticsCookies', null);
				window.location = '/';
			} else {
				this.$store.commit('setAnalyticsCookies', null);
			}
		}
	}
};
</script>
